@if (invoice) {
  <div class="modal-body p-0 flex-fill d-flex flex-column compact-form">
    <div class="card">
      <div class="card-body p-2 pb-3">
        <div class="btn-toolbar mx-0 mb-0 mt-0">
          <div>
            @if (hasChanges()) {
              <button class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
            }
            @if (hasChanges() && !showAsDialog) {
              <button class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
            }
            @if (!hasChanges() && !showAsDialog) {
              <button class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>
            }
            @if (!hasChanges()) {
              <button (click)="email()" class="btn btn-sm btn-secondary me-2">Email Invoice</button>
            }
            @if (!hasChanges()) {
              <button class="btn btn-sm btn-secondary me-4" (click)="print()">Print Invoice</button>
            }
            @if (!hasChanges()) {
              <button class="btn btn-sm btn-danger ms-4 me-4" (click)="delete()">Delete Invoice</button>
            }
            @if (!hasChanges() && !invoice.paid) {
              <button class="btn btn-sm btn-success ms-4" (click)="markAsPaid()">Mark As Paid</button>
            }
          </div>
          <div class="ms-auto d-flex align-items-center">
            <ng-container>
              @if (invoice.paid) {
                <h1 class="mt-2 me-5" style="color: green; font-weight: bold">PAID</h1>
              }
              <label class="mt-2 me-2">Invoice Date</label>
              <dx-date-box class="me-3" [(value)]="invoice.invoiceDate" width="150px"></dx-date-box>
            </ng-container>
          </div>
        </div>
        @if (invoice) {
          <dx-form [formData]="invoice" [colCount]="5" validationGroup="mainValidationGroup">
            <dxi-item itemType="group" caption="Person">
              <dxi-item [label]="{ text: 'Person' }">
                <div *dxTemplate>
                  <dx-select-box
                    [(value)]="invoice.personId"
                    [items]="people"
                    valueExpr="id"
                    displayExpr="displayNameLastFirst"
                    searchMode="contains"
                    (onValueChanged)="personSelectionChanged($event)"
                    [disabled]="true"
                    >
                  </dx-select-box>
                </div>
                <!-- <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule> -->
              </dxi-item>
              <dxi-item dataField="name" [label]="{ text: 'Name' }">
                <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
              </dxi-item>
              <dxi-item dataField="phone" [label]="{ text: 'Mobile' }">
                <!-- <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule> -->
              </dxi-item>
              <dxi-item dataField="address" [label]="{ text: 'Address' }"></dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="city" [label]="{ text: 'City' }"></dxi-item>
                <dxi-item dataField="state" [label]="{ text: 'State' }"></dxi-item>
                <dxi-item dataField="zip" [label]="{ text: 'Zip' }"></dxi-item>
              </dxi-item>
              <dxi-item dataField="email" [label]="{ text: 'Email' }">
                <!-- <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule> -->
              </dxi-item>
              <!-- <dxi-item *ngIf="invoice" dataField="customerTaxCode.name" [label]="{ text: 'Tax Code' }" [editorOptions]="{ disabled: true }"> </dxi-item> -->
              <!-- <dxi-item itemType="group" [colSpan]="1" [colCount]="2">
              <dxi-item dataField="invoiceNumber" [label]="{ text: 'Invoice #' }" [editorOptions]="{ readOnly: true }"></dxi-item>
              <dxi-item
                dataField="pONumber"
                [label]="{ text: 'PO Number' }"
                [editorOptions]="{ readOnly: showAsDialog }"
                [isRequired]="invoice.customer?.requirePoOnInvoices"
                >
              </dxi-item>
            </dxi-item> -->
            <!-- @if (invoice.referencedInvoice) {
            <dxi-item [label]="{ text: 'Reference Invoice #' }">
              <div *dxTemplate class="mb-2">
                <a [routerLink]="['/invoices/' + invoice.referencedInvoiceId]">{{ invoice.referencedInvoice.invoiceNumber }}</a>
              </div>
            </dxi-item>
            } @if (creditNumbers?.length > 0) {
            <dxi-item [label]="{ text: 'Credit #' }">
              <div *dxTemplate class="mb-2 item-list">
                @for (creditNumber of creditNumbers; track creditNumber.id) {
                  <a [routerLink]="['/invoices/' + creditNumber.id]">{{ creditNumber.invoiceNumber }}</a>
                }
              </div>
            </dxi-item>
            } -->
          </dxi-item>
          <!-- <dxi-item itemType="group" caption="Ship Address" [colSpan]="2">
          <dxi-item dataField="shipTo" [label]="{ visible: false }" editorType="dxTextArea" [editorOptions]="{ readOnly: showAsDialog, height: '115px' }"></dxi-item>
        </dxi-item> -->
        <dxi-item itemType="group" caption="Info">
          <dxi-item dataField="invoiceNumber" [editorOptions]="{ readOnly: true }"></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Summary">
          <dxi-item dataField="subTotal" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
          <dxi-item dataField="total" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
          <dxi-item [label]="{ text: 'Donation Eligible' }">
            <div *dxTemplate>
              <dx-number-box [value]="invoice.donationTotal" [disabled]="true" [format]="'$#,##0.00##'"> </dx-number-box>
            </div>
          </dxi-item>
          <dxi-item dataField="balance" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', disabled: true }"></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Payments">
          <dxi-item
            dataField="paymentMethod"
            [label]="{ text: 'Method' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: paymentMethods, readOnly: false }"
          ></dxi-item>
          @if (invoice.paymentMethod === 'Check') {
            <dxi-item dataField="checkNumber"></dxi-item>
          }
          <dxi-item dataField="paidAmount" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', step: 0 }"></dxi-item>
          <dxi-item dataField="paid" editorType="dxDateBox" [disabled]="true"></dxi-item>
          <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
          <!-- <dxi-item
          dataField="paymentLinesTotal"
          [label]="{ text: 'Payments' }"
          editorType="dxNumberBox"
          [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
        ></dxi-item>
        <dxi-item [label]="{ text: 'Credits' }">
          <div *dxTemplate>
            <dx-number-box [value]="creditAmount" format="$#,##0.00##" [readOnly]="true"></dx-number-box>
          </div>
        </dxi-item>
        <dxi-item dataField="balance" editorType="dxNumberBox" [label]="{ text: 'Balance' }" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item> -->
      </dxi-item>
    </dx-form>
  }
</div>
</div>
<!-- OrderLines Data Grid -->
<div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }">
  <dx-data-grid
    #linesGrid
    height="200"
    [dataSource]="invoiceLines"
    keyExpr="id"
    [columnAutoWidth]="false"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onRowDblClick)="onRowDoubleClick($event)"
    (onRowPrepared)="rowPrepare($event)"
    (onExporting)="onExporting($event)"
    class="lines-grid"
    >
    <dxi-column dataField="lineNumber" caption="Line #" width="90" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
    <dxi-column dataField="auctionPurchase.auctionItem.type" caption="Type" width="150"></dxi-column>
    <dxi-column dataField="partNumber" caption="Item" width="250"></dxi-column>
    <dxi-column dataField="description" caption="Description" width="300"></dxi-column>
    <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" width="65"></dxi-column>
    <dxi-column dataField="price" [editorOptions]="{ step: 0 }" caption="Price" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
    <dxi-column dataField="lineTotal" caption="Total" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
    <dxi-column dataField="isDonationQualified" caption="Donation Credit Eligible" width="200"></dxi-column>
    <dxi-column dataField="notes" caption="Notes" width="150"></dxi-column>
    <dxi-column width="100"></dxi-column>
    <dxo-summary>
      <dxi-total-item column="lineTotal" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
    </dxo-summary>
    <div *dxTemplate="let data of 'toolbarButtons'">
      <!-- <button
      class="btn btn-sm btn-primary"
      (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'up')"
      [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
      >
      <i class="fa fa-long-arrow-up" style="min-width: 15px"></i>
    </button>
    <button
      class="btn btn-sm btn-primary ms-1 me-4"
      (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'down')"
      [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
      >
      <i class="fa fa-long-arrow-down" style="min-width: 15px"></i>
    </button> -->
    <!-- <button class="btn btn-sm btn-primary me-2" (click)="openLine()" [hidden]="showAsDialog" [disabled]="readOnly">Add Product</button> -->
    <!-- <button
    class="btn btn-sm btn-success me-2"
    (click)="addProductDelivery(linesGrid.instance.getSelectedRowsData())"
    [hidden]="showAsDialog"
    [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0"
    >
    Add Product Delivery
  </button> -->
  <!-- <button class="btn btn-sm btn-success me-2" (click)="addDelivery()" [hidden]="showAsDialog" [disabled]="readOnly">Add Delivery</button> -->
  <button class="btn btn-sm btn-secondary me-2" (click)="openLine()" [disabled]="readOnly">Add Line</button>
  <button class="btn btn-sm btn-secondary me-2" (click)="addRoundUp()" [disabled]="readOnly">Add Round Up Donation</button>
  <button
    class="btn btn-sm btn-danger me-2"
    (click)="removeLine(linesGrid.instance.getSelectedRowsData())"
    [hidden]="showAsDialog"
    [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0"
    >
    Remove
  </button>
  <button
    class="btn btn-sm btn-warning"
    (click)="toggleIsDonation(linesGrid.instance.getSelectedRowsData()[0])"
    [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
    >
    Toggle Donation Status
  </button>
</div>
<div *dxTemplate="let data of 'toolbarText'"></div>
<dxo-selection [mode]="'single'"></dxo-selection>
<dxo-export [enabled]="true"></dxo-export>
<dxo-state-storing [enabled]="true" [storageKey]="'invoice-detail-grid'"></dxo-state-storing>
</dx-data-grid>
</div>
</div>
}
